/**
 * 简单的className合并工具函数
 * 用于合并多个className字符串，自动处理空格和重复
 */
export function cn(...classes) {
  return classes
    .filter(Boolean)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
}